import ManageCouponAuthorizedUser from '@/views/parametres/configs/param-autorisation-coupons/manage-coupon-authorized-user'
import store_configs from '@/store/mods/parametres/config'

export default {
    name: 'param-autorisation-coupons',
    components: {
        ManageCouponAuthorizedUser
    },
    props: [],
    data() {
        return {
            coupon: {
                coupon_is_active: '',
            },

            save_loading: false,
            divers_info: {},

            fields: [
                { key: 'nom_prenom', label: 'Nom & Prénom.s' }, { key: 'titre', label: 'Titre' }
            ],
            filter_users: "",
            perPage: -1,
            currentPage: 1,
            authorized_users: [],
            user_is_loading: false,
            user_is_empty: true
        }
    },

    computed: {

    },

    mounted() {
        this.divers_info = this.$store.getters['divers_info']

        this.initFields()
        this.getAuthorizedUsers()
    },

    methods: {
        initFields() {
            const fld_keys = Object.keys(this.coupon);
            fld_keys.forEach((key) => {
                if (key == 'coupon_is_active') {
                    this.coupon[key] = this.divers_info[key]
                }

                this.is_loading = false
            });
        },

        getAuthorizedUsers() {
            this.user_is_loading = true
            store_configs.getCouponAuthorizedUsers().then((response) => {
                this.authorized_users = response
                if (response.length == 0) {
                    this.user_is_empty = true
                } else {
                    this.user_is_empty = false
                }
                this.user_is_loading = false
            })
        },

        async saveConfigCoupon() {
            const isValid = await this.$refs.coupon_form.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true

            let form_data = new FormData();
            for (let key in this.coupon) {
                form_data.append(key, this.coupon[key])
            }
            form_data.append('data_type', 'divers_info')

            this.$store.dispatch('saveConfigInfoClinique', form_data).then((response) => {
                if (response > 0) {
                    this.successToast("Enregistrement effectué avec succès.")
                    this.$store.dispatch('getConfigInfoClinique', 'divers_info')
                    this.divers_info = this.$store.getters['divers_info']
                }

                this.save_loading = false
            })
        },
    }
}